// Page Builder canvas support

export const usePbBlockRevs = () =>
  useState<Record<string, number>>('pb-block-revs', () => ({}));

export const usePbBlockKey = () => {
  const revs = usePbBlockRevs();
  return (block: { id?: string | number }): string => {
    const id = String(block?.id ?? '');
    const rev = revs.value[id] || 0;
    return rev ? `${id}-r${rev}` : id;
  };
};
